import { PHeading, PText } from "@porsche-design-system/components-react"
import type { InventoryAndIntakeView } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage, defineMessages, useIntl } from "react-intl"
import { List, Tooltip } from "src/components"
import { VehicleOrderStatus } from "src/screens/vehicleDetails/overviewContainer/components/VehicleOrderStatus"

const messages = defineMessages({
	designationType: {
		defaultMessage: "Designation type",
		id: "vehicleDetails.overview.inventory.designationType",
	},
	inventoryInformation: {
		defaultMessage: "Stock information",
		id: "vehicleDetails.overview.inventory.list.inventoryInformation.title",
	},
	inventoryNumber: {
		defaultMessage: "Inventory Number",
		id: "vehicle.inventoryNumber",
	},
	inventoryStatus: {
		defaultMessage: "Inventory-status",
		id: "vehicleDetails.overview.inventory.inventoryStatus",
	},
	licencePlateNumber: {
		defaultMessage: "Licence plate number",
		id: "vehicleDetails.overview.inventory.licencePlateNumber",
	},
	masterNumberCh: {
		defaultMessage: "Master number",
		id: "vehicleDetails.overview.inventory.masterNumberCh",
	},
	typeKeyNumber: {
		defaultMessage: "Inventory-Number",
		id: "vehicleDetails.overview.inventory.typeKeyNumber",
	},
})

interface InventoryInformationListProps {
	view: InventoryAndIntakeView
}

export const InventoryInformationList = ({ view }: InventoryInformationListProps) => {
	const { formatMessage } = useIntl()
	return (
		<List
			header={
				<PHeading size="sm">
					<FormattedMessage {...messages.inventoryInformation} />
				</PHeading>
			}
		>
			{view.usageType && <List.Item label={formatMessage(messages.designationType)} value={view.usageType} />}
			{view.inventoryNumber && (
				<List.Item label={formatMessage(messages.inventoryNumber)} value={view.inventoryNumber} />
			)}
			{view.typeKeyNumber && (
				<List.Item label={formatMessage(messages.typeKeyNumber)} value={view.typeKeyNumber} />
			)}
			{view.licencePlateNumber && (
				<List.Item label={formatMessage(messages.licencePlateNumber)} value={view.licencePlateNumber} />
			)}
			{view.masterNumberCh && (
				<List.Item label={formatMessage(messages.masterNumberCh)} value={view.masterNumberCh} />
			)}
			{view.inventoryStatus && (
				<List.Item
					label={formatMessage(messages.inventoryStatus)}
					value={
						<Tooltip content={view.inventoryStatus.pvmsStatusHint}>
							<PText weight="semibold">{view.inventoryStatus.inventoryStatusMessage}</PText>
						</Tooltip>
					}
				/>
			)}
			{view.vehicleOrder && (
				<List.Item label="Order Status" value={<VehicleOrderStatus view={view.vehicleOrder} />} />
			)}
		</List>
	)
}
